import { getErrorMsg, logger } from 'lib/logger';
import { QuotaAPICall } from 'reactApp/api/QuotaAPICall';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { loadUserQuotaRequest, loadUserQuotaSuccess } from 'reactApp/modules/userQuota/userQuota.module';
import { call, cancel, put, select, takeEvery } from 'redux-saga/effects';

const callApi = () => new QuotaAPICall().makeRequest();

type AnonymousSelector = ReturnType<typeof UserSelectors.isAnonymous>;

type ApiCall = Awaited<ReturnType<typeof callApi>>;

export function* loadQuota() {
    try {
        const isAnonymous: AnonymousSelector = yield select(UserSelectors.isAnonymous);

        if (isAnonymous) {
            return;
        }

        const { data }: ApiCall = yield call(callApi);

        yield put(loadUserQuotaSuccess(data));
    } catch (error) {
        logger.error(getErrorMsg(error), error);
        yield cancel();
    }
}

export function* watchUserQuota() {
    yield takeEvery(loadUserQuotaRequest.toString(), loadQuota);
}
